import { getSubdomain } from '../utils/helper'
import React from 'react';
import { config } from './domainConfig';
let domainUrl = window.location.origin;
let apiUrl = ''
export let ANALYTICS_API_URL = '';


if (getSubdomain() == 'localhost') {
    ANALYTICS_API_URL = 'https://de-pacman.sam-media.com/api/v2/mstore';
    apiUrl = 'http://localhost:3202/api';
}
else {
    ANALYTICS_API_URL = 'https://de-pacman.sam-media.com/api/v2/mstore';
    apiUrl = `${domainUrl}/api`;
}
export const BASE_API_URL = apiUrl;
export const unsubLinks = {
    za: `http://n.mobio360.com/unsubscribe/za/`,
    ci: `http://n.mobio360.com/unsubscribe/ci/`,
    cd: `http://n.mobio360.com/unsubscribe/cd/`,
    cm: `http://n.mobio360.com/unsubscribe/cm/`,
    tn: `http://n.mobio360.com/unsubscribe/tn/`,
    sn: `http://n.mobio360.com/unsubscribe/sn/`,
    be: `http://n.mobio360.com/unsubscribe/be/?country=be&domain=be.mobio360.com`,
    tr: `http://n.mobio360.com/unsubscribe/tr/?domain=tr.mobio360.com`,
    pt: `http://n.mobio360.com/unsubscribe/pt/`,
    no: `http://n.mobio360.com/unsubscribe/no/`,
    sa: `http://n.mobio360.com/unsubscribe/sa/`,
    kw: `http://n.mobio360.com/unsubscribe/kw/`,
    th: `https://checksubscription.com/?c=th`,
    mx: `https://checksubscription.com/?c=mx`
}
export const unsubscribeText = {
  za: (
    <div className="unsub_text">
      <p>To unsubscribe, dial 135*997#</p>
    </div>
  ),
};


// WEBPACK FOOTER //
// ./src/constants/constants.js